import { render, staticRenderFns } from "./MenuDesktop.vue?vue&type=template&id=b3b6d0ce&scoped=true&"
import script from "./MenuDesktop.vue?vue&type=script&lang=ts&"
export * from "./MenuDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./MenuDesktop.vue?vue&type=style&index=0&id=b3b6d0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b6d0ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/app/components/base/Icon.vue').default,AppHeaderNavPopover: require('/app/components/app/header/NavPopover.vue').default,AppHeaderNavItem: require('/app/components/app/header/NavItem.vue').default,BaseLink: require('/app/components/base/Link.vue').default,AppHeaderNavPopoverGroup: require('/app/components/app/header/NavPopoverGroup.vue').default})
